import {
	type ExperienceData,
	INLINE_RESPONSE_MARK,
	type ExperiencePerformanceConfig as PerformanceConfig,
} from '@atlassian/ufo-experimental/types';

import { getHistogram } from './getHistogram';
import { InlineResultMetricKeys } from './InlineResultMetricKeys';

export const getInlineResultMetrics = (
	data: ExperienceData,
	performanceConfig: PerformanceConfig | null,
): {
	[x: string]: string | number;
} | null => {
	if (data.metrics.endTime === null || data.metrics.startTime === null) {
		return null;
	}

	const responseMark = data.metrics.marks.find((mark) => mark.name === INLINE_RESPONSE_MARK);
	const result = data.metrics.endTime - data.metrics.startTime;
	const response = responseMark ? responseMark.time - data.metrics.startTime : result;
	return {
		[InlineResultMetricKeys.result]: Math.round(result),
		[InlineResultMetricKeys.response]: Math.round(response),
		...getHistogram(data, performanceConfig),
	};
};
